export function Logo({ size = "md", showText = true }) {
  const dim = size === "sm" ? 32 : size === "lg" ? 56 : 42;
  return (
    <div className="flex items-center gap-3" data-testid="soeasy-logo">
      <div
        className="relative flex items-center justify-center rounded-full gold-glow"
        style={{
          width: dim, height: dim,
          background: "linear-gradient(135deg, #1A1D42 0%, #0A0B1A 100%)",
          border: "1.5px solid #B28F4B",
        }}
      >
        <svg width={dim * 0.55} height={dim * 0.55} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2L4 6v6c0 5 3.5 9.5 8 10 4.5-0.5 8-5 8-10V6l-8-4z"
            stroke="#B28F4B" strokeWidth="1.5" fill="rgba(178,143,75,0.1)"
          />
          <path d="M9 12l2 2 4-4" stroke="#B28F4B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      {showText && (
        <div className="font-heading leading-tight">
          <div className="text-[#B28F4B] font-bold tracking-tight" style={{ fontSize: dim * 0.4 }}>
            SOEASY
          </div>
          <div className="text-white/50 text-[10px] uppercase tracking-[0.25em] font-medium -mt-0.5">
            Security · Governance
          </div>
        </div>
      )}
    </div>
  );
}
